// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3VMhd","buttons":"Footer_buttons__G3sEs"};